// Consumidor final (indFinal) — F0h. A regra é do backend
// (services/consumidor_final.py); aqui só a tela: quando perguntar e o que
// mostrar. CPF ou não contribuinte: sempre consumidor final (regra 696 da
// SEFAZ). Contribuinte (indicador 1 ou 2): o operador escolhe; o padrão vem do
// cadastro do cliente e, sem ele, fica vazio (obrigatório escolher).

// CPF/CNPJ sem máscara (o CNPJ alfanumérico mantém as letras).
const digitos = (v) => String(v || '').replace(/[^0-9A-Za-z]/g, '').toUpperCase();

export function consumidorFinalObrigatorio(cliente) {
  if (!cliente) return true;
  const ind = Number(cliente.indicador_ie ?? 9);
  return digitos(cliente.cpf_cnpj).length === 11 || (ind !== 1 && ind !== 2);
}

// Valor da nota ao escolher o destinatário. Em devolução (finalidade 4) o padrão
// do cliente não vale: o valor vem da nota original (ou da pergunta).
export function valorInicialConsumidorFinal(cliente, finalidade) {
  if (consumidorFinalObrigatorio(cliente)) return true;
  if (Number(finalidade) === 4) return null;
  return typeof cliente.consumidor_final === 'boolean' ? cliente.consumidor_final : null;
}

// O que o passo "Dados Cliente" faz com o consumidor final:
//   'obrigatorio' (CPF/não contribuinte), 'copiado' (devolução: a nota original
//   está no sistema), 'aguardando' (devolução sem chave ainda), 'perguntar'.
// cfDevolucao = resposta de /nfe/devolucao/consumidor-final (null = sem chave).
export function modoConsumidorFinal(cliente, finalidade, cfDevolucao) {
  if (consumidorFinalObrigatorio(cliente)) return 'obrigatorio';
  if (Number(finalidade) !== 4) return 'perguntar';
  if (!cfDevolucao || !cfDevolucao.chaves) return 'aguardando';
  return typeof cfDevolucao.consumidor_final === 'boolean' ? 'copiado' : 'perguntar';
}

// <select> do cadastro: true/false/null <-> 'sim'/'nao'/''.
export function escolhaParaSelect(v) {
  return v === true ? 'sim' : v === false ? 'nao' : '';
}
export function selectParaEscolha(s) {
  return s === 'sim' ? true : s === 'nao' ? false : null;
}

// Erro do passo "Dados Cliente" (null = pode seguir). Em devolução só cobra a
// escolha quando a original não está no sistema (modo 'perguntar').
export function erroConsumidorFinal(cliente, escolha, modo = 'perguntar') {
  if (!cliente || consumidorFinalObrigatorio(cliente)) return null;
  if (modo !== 'perguntar') return null;
  if (typeof escolha !== 'boolean') {
    return 'Destinatário contribuinte: informe se a compra é para uso e consumo (consumidor final) ou para revenda/industrialização.';
  }
  return null;
}
